import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import { Card, CardContent } from './ui/card';

export const LoadingMessageCard: React.FC<{ message?: React.ReactNode }> = ({
  message,
}) => (
  <Card>
    <CardContent className="items-center justify-items-center text-center">
      <LoadingSpinner />
      <div className="pt-2">{message ?? 'Cargando'}</div>
    </CardContent>
  </Card>
);
